<script lang="ts" setup>
import { Heading, Text } from '~ds/components/ui/typography';

interface Props {
  title: string;
  description: string;
}

defineProps<Props>();
</script>

<template>
  <section data-testid="schools-landing-payoff">
    <div class="relative overflow-hidden rounded-card-lg px-6 py-20 lg:px-20 lg:py-32">
      <NuxtPicture
        format="avif,webp"
        src="/images/kui/schools/landing/payoff-bg.webp"
        sizes="100vw lg:1069px"
        loading="lazy"
        :img-attrs="{ alt: '', class: 'absolute inset-0 size-full object-cover' }"
      />

      <div class="relative flex flex-col items-center gap-12 text-center max-w-2xl mx-auto">
        <Heading
          as="h2"
          size="3xl"
          class="text-primary-foreground"
          data-testid="schools-landing-payoff-title"
        >
          {{ title }}
        </Heading>
        <Text
          size="xl"
          class="text-primary-foreground"
          weight="medium"
          data-testid="schools-landing-payoff-description"
        >
          {{ description }}
        </Text>

        <div
          v-if="$slots.actions"
          class="flex w-full flex-col gap-3 sm:w-auto sm:flex-row sm:items-center"
          data-testid="schools-landing-payoff-actions"
        >
          <slot name="actions" />
        </div>
      </div>
    </div>
  </section>
</template>
